import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './services/config.service';
import { Observable } from 'rxjs';

export function initializeApp(configService: ConfigService): () => Observable<any> {
  return () => configService.loadConfig();
}

export const appInitializerProviders = [
  {
    provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps: [ConfigService],
    multi: true
  }
];
